import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/HomeView.vue"),
  },
  {
    path: "/go-service",
    name: "service",
    component: () => import("../views/Go-serviceView.vue"),
  },
  {
    path: "/lokasi",
    name: "lokasi",
    component: () => import("../views/LokasiView.vue"),
  },
  {
    path: "/referral",
    name: "referral",
    component: () => import("../views/RefferalView.vue"),
  },
  {
    path: "/franchise",
    name: "franchise",
    component: () => import("../views/FranchiseView.vue"),
  },
  {
    path: "*",
    name: "not",
    component: () => import("../views/NotFoundView.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
